<script setup></script>

<template>
  <div>Invalid Scene</div>
</template>
